import parse from "html-react-parser"
import * as React from "react"
export const convertMessage = message => {
  const parsedText = parse(message)

  const onClick = (e, link) => {
    e.stopPropagation()
    const targetWindow: Window = window.open(link, "_blank")

    return targetWindow
  }

  let updatedText = null
  if (Array.isArray(parsedText)) {
    updatedText = parsedText.map((element, index) => {
      if (element.type === "a") {
        return React.cloneElement(element, {
          onTouchEnd: e => onClick(e, element.props.children),
          onnClick: e => onClick(e, element.props.children)
        })
      }
      return element
    })
  } else {
    // @ts-ignore
    if (parsedText?.type === "a") {
      // @ts-ignore
      return React.cloneElement(parsedText, {
        // @ts-ignore
        onTouchEnd: e => onClick(e, parsedText.props.children),
        // @ts-ignore
        onClick: e => onClick(e, parsedText.props.children)
      })
    } else {
      updatedText = parsedText
    }
  }

  return updatedText
}
